import { storageApi } from '@d/sdk'

export async function download(path: string[] | string): Promise<Blob> {
  if (!Array.isArray(path))
    return await storageApi.download(path)
  return await storageApi.download(path.join('/'))
}

export function clickDownload(blob: Blob, name: string): void {
  const url = window.URL.createObjectURL(blob)
  // Create hidden link element and assing the object url to it
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = name
  anchor.click()
  // Revoke after click
  window.URL.revokeObjectURL(url)
}
